// extracted by mini-css-extract-plugin
export default {"nav":"section-nav_nav__gGTqN","list":"section-nav_list__fAQXl","link":"section-nav_link__OFBTg"};